export const SET_WINDOW_WIDTH = 'SET_WINDOW_WIDTH'

export const SET_PRODUCT = 'SET_PRODUCT'

export const SET_LANG = 'SET_LANG'

export const SET_PRODUCTSH = 'SET_PRODUCTSH'

export const SET_PRODUCTLIST = 'SET_PRODUCTLIST'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js